import React from 'react';
import { toast } from 'react-toastify';
import Forum from '../models/Forum';
import useLocale from './useLocale';
import useModal from './useModal';

function useForums(paginate = true) {
  const { l } = useLocale();
  const { showModal, closeModal, openModal } = useModal();

  const [forums, setForums] = React.useState([]);
  const titleRef = React.useRef(null);
  const descriptionRef = React.useRef(null);

  const getForums = React.useCallback(
    function ({ page, limit, filters = {} }) {
      Forum.get(filters['user.name'], page, paginate, limit, filters['title']).then(res =>
        setForums(res)
      );
    },
    [paginate]
  );

  // const getForums = () => {
  //   Forum.get()
  //     .then(res => setForums(res))
  //     .catch(err => toast.error(l('general_error')));
  // };

  React.useEffect(() => {
    getForums({});
  }, []);

  const handleSubmit = e => {
    e.preventDefault();

    const forum = {
      title: titleRef.current.value,
      description: descriptionRef.current.value,
    };

    Forum.save(forum)
      .then(res => {
        toast.success(l('forum_added'));

        titleRef.current.value = '';
        descriptionRef.current.value = '';

        closeModal();
        getForums({});
      })
      .catch(err => toast.error(l('general_error')));
  };

  const handleDelete = id => {
    Forum.delete(id)
      .then(res => {
        toast.success(l('forum_deleted'));
        getForums({});
      })
      .catch(err => toast.error(l('general_error')));
  };

  return {
    openModal,
    showModal,
    closeModal,
    titleRef,
    descriptionRef,
    handleSubmit,
    forums,
    handleDelete,
    getForums,
  };
}

export default useForums;
